import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 30px;
  justify-content: center;
`;
